import type { FaireProductEntity } from "../../entity_types/product";

export const p_u9akrskcdh: FaireProductEntity = {
  token: "p_u9akrskcdh",
  type: "product",
  name: "Girls' Cartoon Print Cotton Sweatshirt Casual Style",
  brandToken: "b_fm9b27ve2d",
  brandName: "The Find Peaks",
  imageUrl:
    "https://cdn.faire.com/fastly/c189bff8597d21c420b23f43cfd85c5715ca4b74eb5c66c7d493cff04138e6a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0231c61c8dd4b9d6deb1415d97124dbc5acc933269430881cecd9a4b1ab1d4b3.jpeg",
    "https://cdn.faire.com/fastly/dcf1fa3a83e49a7dbeb248bbfe2623864892428fae5445b8c80251c457503e76.jpeg",
    "https://cdn.faire.com/fastly/5380a933d460158586ad47712a36bc1f459ec748f577a29f81492600dd9987a1.jpeg",
    "https://cdn.faire.com/fastly/e2e9023df0fe12636a0000cb743a64321df2c830ab9c0522bdc1065fe76aafb7.jpeg",
    "https://cdn.faire.com/fastly/4450f35bff7ceea3ad74c131cb18b7518ab47d546f69fe6577fea680a3b1999d.jpeg",
    "https://cdn.faire.com/fastly/a3d996c223994aceeb81f3a26788bc5306547d3102f24c4b4538fda958ee9089.jpeg",
  ],
  priceDollars: 5.94,
  description:
    "This adorable sweatshirt is designed for girls aged 3 to 8, featuring a cute cartoon print that brings fun to everyday wear. Made from 95% cotton, it provides a soft touch and comfortable fit. The long sleeves make it ideal for all-season layering.\n\nFeatures:\n\n * Made from 95% Cotton for Comfort \n * Soft Fabric Treatment for Gentle Touch \n * Regular Fit – Consider Sizing Up for a Looser Fit \n * Suitable for All Seasons: Spring, Fall, and Winter \n * Available in Various Heights: 100, 110, 120, 130, 140, 150 cm \n * Colorful Cartoon Pattern \n * Ideal for Casual and Leisure Activities \nThis stylish sweatshirt combines comfort and playful designs, making it a perfect choice for your little one's wardrobe. Versatile for various occasions, it allows for easy mixing and matching with other outfits.\n",
  tags: [],
  msrpDollars: 11.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:40.133Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
